export const getDiscount = (price: number, originPrice: number) => Math.ceil(100 - price * 100 / originPrice)

export const getPerCoinValue = (price: number, credits: number) => (price / credits).toFixed(2)

export const PRICE = {
  CHAT: 2,
  CHAT_PHOTO_SEND: 10,
  CHAT_DISAPPEARING_PHOTO_SEND: 20,
  CHAT_DISAPPEARING_PHOTO_VIEW: 20,
  CHAT_VIDEO_SEND: 40,
  CHAT_VIDEO_VIEW: 40,
  CHAT_DISAPPEARING_VIDEO_SEND: 40,
  CHAT_DISAPPEARING_VIDEO_VIEW: 40,
}